import React from 'react';
import type {IntlShape} from 'react-intl';
import {Table} from '@/web-components';
import Util from '../../../../forecast-app/shared/util/util';
import {AgentRowActions} from '../../../../forecast-app/shared/components/agentic-workers/AgentRowActions';
import {getVisibleAgentsForRow} from '../../../../forecast-app/shared/components/agentic-workers/agentRegistry';
import {INVOICING_AGENT_PAGE, INVOICING_AGENT_ROW_TYPE, projectBillingAgentRow} from '../invoicingAgentPages';

const AGENT_COLUMN_KEY = 'agent';

type InvoiceCreationAgentColumns = {
	isVisible: boolean;
	headerColumns: JSX.Element[];
	totalsColumns: JSX.Element[];
	projectColumns: (projectGlobalId: string) => JSX.Element[];
};

// The table gives its sticky, padded wrapper to the first column even when that column is hidden, so the agent
// column exists only while an agent shows. Its pieces are arrays because the table reads every child's type, which
// a `false` child or a Fragment breaks. With the agent column first, the project column needs `usePadding={isVisible}`.
export const getInvoiceCreationAgentColumns = (intl: IntlShape): InvoiceCreationAgentColumns => {
	const isVisible =
		getVisibleAgentsForRow(INVOICING_AGENT_PAGE.INVOICE_CREATION, INVOICING_AGENT_ROW_TYPE.PROJECT_BILLING_ROW).length > 0;
	if (!isVisible) {
		return {
			isVisible,
			headerColumns: [],
			totalsColumns: [],
			projectColumns: () => [],
		};
	}
	return {
		isVisible,
		headerColumns: [
			<Table.HeaderColumn key={AGENT_COLUMN_KEY} align={'left'} visible={true} width={'MEDIUM'}>
				<Table.HeaderColumn.Title>{intl.formatMessage({id: 'nova_invocation.column.header'})}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>,
		],
		totalsColumns: [<Table.Column key={AGENT_COLUMN_KEY} />],
		projectColumns: projectGlobalId => [
			<Table.Column key={AGENT_COLUMN_KEY}>
				<AgentRowActions
					page={INVOICING_AGENT_PAGE.INVOICE_CREATION}
					row={projectBillingAgentRow(Util.getIdFromBase64String(projectGlobalId))}
				/>
			</Table.Column>,
		],
	};
};
